import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { DatabaseContainerLoader } from '@confluence/confluence-databases/entry-points/DatabaseContainerLoader.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import SpaceRestriction from '../../SpaceBase/SpaceRestriction.js';
import { LazyDwellTime, LazyConsumptionViewedAndCompletedEventTracker } from '../lazyComponents.js';

export const DatabaseViewRoute: {
	({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(routeMatch: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					contentId: string;
				};
			};
			pageState: {
				contentId: string;
				spaceKey: string;
				contentType: string;
				routeName: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			isViewPage: boolean;
		};
	};
} = ({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element => (
	<SpaceRestriction spaceKey={spaceKey} contentId={contentId}>
		<DatabaseContainerLoader contentId={contentId} spaceKey={spaceKey} />
		<LazyDwellTime />
		<LazyConsumptionViewedAndCompletedEventTracker spaceKey={spaceKey} source="DatabaseViewRoute" />
	</SpaceRestriction>
);

DatabaseViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				contentId: string;
			};
		};
		pageState: {
			contentId: string;
			spaceKey: string;
			contentType: string;
			routeName: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
		isViewPage: boolean;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'databaseScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'database',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
